export const speicificgodstemple = [
  {
    id: 1,
    title: "God Specific Puja",
    imageSrc:
      "https://d18guwlcxyb2ak.cloudfront.net/wp-content/uploads/2021/09/10112148/FESTIVAL-SPECIFIC-PUJA.jpg",
    altText: "GOD SPECIFIC PUJA",
    price: "50.00",
  },
  {
    id: 2,
    title: "Hanuman Puja",
    imageSrc: "assets/Carosuel/hanuman.jpg",
    altText: "Hanuman Puja",
    price: "40.00",
  },
  {
    id: 3,
    title: "Lakshmi Puja",
    imageSrc:
      "https://d18guwlcxyb2ak.cloudfront.net/wp-content/uploads/2021/09/10112148/FESTIVAL-SPECIFIC-PUJA.jpg",
    altText: "Lakshmi Puja",
    price: "60.00",
  },
  {
    id: 4,
    title: "Navratri Puja",
    imageSrc: "assets/Carosuel/hanuman.jpg",
    altText: "Navratri Puja",
    price: "75.00",
  },
  // {
  //   id: 5,
  //   title: "Vastu Puja",
  //   imageSrc:
  //     "https://d18guwlcxyb2ak.cloudfront.net/wp-content/uploads/2021/09/10112148/FESTIVAL-SPECIFIC-PUJA.jpg",
  //   altText: "Vastu Puja",
  //   price: "30.00",
  // },
  // {
  //   id: 6,
  //   title: "Sudarshan Puja",
  //   imageSrc: "assets/Carosuel/hanuman.jpg",
  //   altText: "Sudarshan Puja",
  //   price: "45.00",
  // },
  // {
  //   id: 7,
  //   title: "Ganesha Puja",
  //   imageSrc:
  //     "https://d18guwlcxyb2ak.cloudfront.net/wp-content/uploads/2021/09/10112148/FESTIVAL-SPECIFIC-PUJA.jpg",
  //   altText: "Ganesha Puja",
  //   price: "50.00",
  // },
  // {
  //   id: 8,
  //   title: "Satyanarayan Puja",
  //   imageSrc: "assets/Carosuel/hanuman.jpg",
  //   altText: "Satyanarayan Puja",
  //   price: "55.00",
  // },
];

// export const SarpaDosha = [
//   {
//     id: 1,
//     title: "Sarpa dosha pooja",
//     price: 3500,
//     image: "assets/Remedy/KalaSarpaDosha.png",
//   },
//   {
//     id: 2,
//     title: "Sarpa Shanti pooja",
//     price: 3500,
//     image: "assets/Remedy/KalaSarpaDosha.png",
//   },
//   {
//     id: 3,
//     title: "Sarpabali pooja",
//     price: 3500,
//     image: "assets/Remedy/KalaSarpaDosha.png",
//   },
//   {
//     id: 4,
//     title: "Ashlesha pooja",
//     price: 3300,
//     image: "assets/Remedy/KalaSarpaDosha.png",
//   },
//   {
//     id: 5,
//     title: "Ashlesha Bali",
//     price: 19000,
//     image: "assets/Remedy/KalaSarpaDosha.png",
//   },
//   {
//     id: 6,
//     title: "Navanpooj",
//     price: 3500,
//     image: "assets/Remedy/KalaSarpaDosha.png",
//   },
//   {
//     id: 7,
//     title: "Narayana Bali pooja",
//     price: 3500,
//     image: "assets/Remedy/KalaSarpaDosha.png",
//   },
// ];


export const SarpaDosha = [
  // {
  //   id: 1,
  //   title: "Sarpa dosha pooja",
  //   price: 3500,
  //   image: "assets/Remedy/KalaSarpaDosha.png",
  // },
  // {
  //   id: 2,
  //   title: "Sarpa Shanti pooja",
  //   price: 3500,
  //   image: "assets/Remedy/KalaSarpaDosha.png",
  // },
  {
    id: 3,
    title: "Sarpabali pooja",
    price: 3500,
    image: "assetstwo/sarpa/Sarpa-bali-Mandalam.jpg",
  },
  {
    id: 4,
    title: "Ashlesha pooja",
    price: 3500,
    image: "assetstwo/sarpa/Ashlesha pooja.jpg",
  },
  {
    id: 5,
    title: "Ashlesha Bali",
    price: 19000,
    image: "assetstwo/sarpa/Ashlesha Bali.jpg",
  },
  {
    id: 6,
    title: "Navanpooj",
    price: 3500,
    image: "assetstwo/sarpa/Navanpooj (Navagraha Pooja).jpg",
  },
  // 
  
  
];


export const homams = [
  {
    id: 1,
    name: "Maha Lakshmi Homam (Homam for Devi)",
    price: 7000,
    image: "assetstwo/Homaimages/Maha Lakshmi Homam(Homam for Devi).jpg",
  },
  {
    id: 2,
    name: "Saraswathi Homam (Homam for Education)",
    price: 7000,
    image: "assetstwo/Homaimages/Saraswathi Homam(Homam for Devi).jpg",
  },
  {
    id: 3,
    name: "Maha Ganapathy Homa (Homam for Ganesh, Health & Wealth)",
    price: 7000,
    image: "assetstwo/Homaimages/Maha Ganapathy Homa(Homam for Ganesh).jpg",
  },
  {
    id: 4,
    name: "Navagraha Homa(Homam for Graha Dosha Nivarti )",
    price: 7000,
    image: "assetstwo/Homaimages/Navagraha Homa(Homam for Navagraha).jpg",
  },
  // {
  //   id: 5,
  //   name: "Maha Mrityunjaya Homam (Homam for Shiva & Health)",
  //   price: 7000,
  //   image: "assetstwo/Homaimages/Maha Mrityunjaya Homam(Homam for Shiva).jpg",
  // },
  // {
  //   id: 6,
  //   name: "Lakshmi Kubera Homam (Homam for Kubera & Wealth)",
  //   price: 7000,
  //   image: "assetstwo/Homaimages/Lakshmi Kubera Homam(Homam for Kubera).jpg",
  // },
  // {
  //   id: 7,
  //   name: "Aditya Homam (Homam for Surya & Spiritual Elevation)",
  //   price: 7000,
  //   image: "assetstwo/Homaimages/Aditya Homam (Homam for Surya).jpg",
  // },
  // {
  //   id: 8,
  //   name: "Santhana Gopala Homam (Homam for Conceiving a Child & Vishnu)",
  //   price: 7000,
  //   image: "assetstwo/Homaimages/Santhana Gopala Homam(Homam for Vishnu).jpg",
  // },
  // {
  //   id: 9,
  //   name: "Chandi Homa (Homam for Alleviating Negativity)",
  //   price: 19000,
  //   image:
  //     "assetstwo/Homaimages/Chandi Homa (Homam for Alleviating Negativity).jpg",
  // },
  // {
  //   id: 10,
  //   name: "Maha Sudharshana Homam (Homam for Alleviating Negativity)",
  //   price: 7000,
  //   image:
  //     "assetstwo/Homaimages/Maha Sudharshana Homam(Homam for Alleviating Negativity).jpg",
  // },
  // {
  //   id: 14,
  //   name: "Ayushya Homam (Homam for Health)",
  //   price: 7000,
  //   image: "assets/Homaimages/Ayushya Homam(Homam for Health).jpg",
  // },
  // {
  //   id: 17,
  //   name: "Swayamvara Parvathy Homam (Homam for Marriage)",
  //   price: 7000,
  //   image:
  //     "assets/Homaimages/Swayamvara Parvathy Homam (Homam for Marriage).jpg",
  // },
  // {
  //   id: 18,
  //   name: "Shri Rudra Homam (Homam for Spiritual Elevation)",
  //   price: 15000,
  //   image:
  //     "assets/Homaimages/Shri Rudra Homam (Homam for Spiritual Elevation).jpg",
  // },
  // {
  //   id: 20,
  //   name: "Bhoo Varaha Homam (Homam for Vaastu related problems)",
  //   price: 7000,
  //   image:
  //     "assets/Homaimages/Bhoo Varaha Homam (Homam for Vaastu related problems).jpg",
  // },
  // {
  //   id: 23,
  //   name: "Sri Suktha Homam (Homam for Wealth)",
  //   price: 7000,
  //   image: "assets/Homaimages/Sri Suktha Homam(Homam for Wealth).jpg",
  // },
];



export const tades = [
  {
    id: 1,
    title: "Karma Tade",
    price: 3500,
    image: "assetstwo/tade/Karma Tade.jpg",
  },
  {
    id: 2,
    title: "Shanthi Tade",
    price: 3500,
    image: "assetstwo/tade/Shanthi Tade.jpg",
  },
  {
    id: 3,
    title: "Shatru Tade",
    price: 3500,
    image: "assetstwo/tade/Shatru Tade.jpg",
  },
  {
    id: 4,
    title: "Prema /Prethi Tade",
    price: 3500,
    image: "assetstwo/tade/Prethi Tade.jpg",
  },
  // {
  //   id: 5,
  //   title: "Maduve Tade",
  //   price: 3500,
  //   image: "assetstwo/tade/Maduve Tade.jpg",
  // },
  // {
  //   id: 6,
  //   title: "Matada Tade",
  //   price: 3500,
  //   image: "assetstwo/tade/Matada Tade.jpg",
  // },
  // {
  //   id: 7,
  //   title: "Pathi /Sathi Shapa Tade",
  //   price: 3500,
  //   image: "assetstwo/sarpa/Pathi_Sathi Shapa Tade puj.jpg",
  // },
  // {
  //   id: 8,
  //   title: "Jana (Ketta) Drusti Tade",
  //   price: 3500,
  //   image: "assetstwo/tade/Jana (Ketta) Drusti Tade.jpg",
  // },
  // {
  //   id: 9,
  //   title: "Nara (Hote Huri) Dusti Tade",
  //   price: 3500,
  //   image: "assetstwo/tade/Nara (Hote Huri) Dusti Tade puja.jpg",
  // },
  // {
  //   id: 10,
  //   title: "Karya Dusti Tade",
  //   price: 3500,
  //   image: "assetstwo/tade/Karya Dusti Tade.jpg",
  // },
  // {
  //   id: 11,
  //   title: "Money Tade",
  //   price: 3500,
  //   image: "assetstwo/tade/Money Tade.jpg",
  // },
  // {
  //   id: 12,
  //   title: "Health Tade",
  //   price: 3500,
  //   image: "assetstwo/tade/Helath Tade.jpg",
  // },
  // {
  //   id: 13,
  //   title: "Graha Tade",
  //   price: 3500,
  //   image: "assetstwo/tade/Graha Tade.jpg",
  // },
  // {
  //   id: 14,
  //   title: "Dosha Tade",
  //   price: 3500,
  //   image: "assetstwo/tade/Dosha Tade.jpg",
  // },
  // {
  //   id: 15,
  //   title: "Sthree Dosa Tade",
  //   price: 3500,
  //   image: "assetstwo/tade/Prethi Tade.jpg",
  // },
];